import { getOptionFunction } from '../pages/Explore/components/Sentence/helpers/treeData';

export const getAvailableFunctionsFromMetrics = (
    metrics: AvailableMetricT[] | ExploreMetricT[] | undefined,
): string[] => {
    if (!metrics) return [];
    const metricsFunctions = metrics.map((metric) =>
        getOptionFunction(metric.functions || []),
    );
    const uniqAvailableFunctions = Array.from(new Set(metricsFunctions.flat()));
    return uniqAvailableFunctions;
};
